import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  languages as allLanguages,
  translatedLanguageNames,
  withLocale,
  localeShape,
  language,
} from '../../locale'

class LocaleSwitcher extends React.Component {
  static propTypes = {
    inverted: PropTypes.bool,
    desktop: PropTypes.bool,
    locale: localeShape.isRequired,
    languages: PropTypes.array,
    onLanguageChange: PropTypes.func,
    redirect: PropTypes.bool,
  }

  static defaultProps = {
    languages: allLanguages,
  }

  listRef = React.createRef()

  state = {
    menuOpen: false,
    show: true,
  }

  componentWillUnmount = () => {
    document.removeEventListener('click', this.documentClickListener)
  }

  documentClickListener = e => {
    if (!this.listRef.current.contains(e.target)) {
      this.hideList()
    }
  }

  showList = () => {
    document.addEventListener('click', this.documentClickListener)
    this.setState({ menuOpen: true })
  }

  hideList = () => {
    document.removeEventListener('click', this.documentClickListener)
    this.setState({ menuOpen: false })
  }

  toggleList = () => {
    if (this.state.menuOpen) {
      this.hideList()
    } else {
      this.showList()
    }
  }

  render = () => {
    const { language: currentLanguage, setLanguage } = this.props.locale

    return (
      <div
        className={classNames('c-language-switcher', {
          'c-language-switcher--inverted': this.props.inverted,
          'c-language-switcher--desktop': this.props.desktop,
        })}
      >
        <button
          className={classNames('c-language-switcher__button', {
            'c-language-switcher__button--open': this.state.menuOpen,
            'c-menu-bar__link': this.props.desktop,
          })}
          onClick={this.toggleList}
          aria-controls="locale-dropdown"
          data-testid="language-list-toggler"
          data-uid="language-list-toggler"
          type="button"
        >
          {this.props.desktop && (
            <span className="c-menu-bar__link-text">
              <span className="visually-hidden">Language: </span>
              {currentLanguage}
            </span>
          )}
          {!this.props.desktop && (
            <>
              <span className="visually-hidden">Language: </span>
              {currentLanguage}
            </>
          )}
        </button>
        {this.state.menuOpen && (
          <div
            className={classNames('c-language-switcher__list', {
              'c-language-switcher__list--open': this.state.menuOpen,
            })}
            id="locale-dropdown"
            ref={this.listRef}
          >
            <ul>
              {this.props.languages.map(code => (
                <li
                  key={code}
                  className="c-language-switcher__item"
                  lang={code}
                  data-testid="language-list"
                >
                  <a
                    className={classNames('c-language-switcher__link', {
                      'c-language-switcher__link--active':
                        currentLanguage === code,
                    })}
                    href={code === language.ENGLISH ? '/' : `/${code}`}
                    onClick={e => {
                      e.preventDefault()
                      setLanguage(code, this.props.redirect)
                      this.props.onLanguageChange &&
                        this.props.onLanguageChange(code)
                      this.hideList()
                    }}
                    data-uid="language-list-toggler-language"
                  >
                    <span>{translatedLanguageNames[code]}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    )
  }
}

export default withLocale(LocaleSwitcher)
